import { reactive } from "vue";

// State store for the left side bar which displays navigation and the main menu
export const useSideBarStore = reactive({
    isOpen: true,
    toggle() {
        this.isOpen = !this.isOpen;
    },
});
